import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

export function getRequiredEntity(entity: Entities) {
  return [Entities.deliveryNote, Entities.inboundDeliveryNote].includes(entity)
    ? undefined
    : [Entities.order, Entities.demand].includes(entity)
    ? Entities.supplier
    : Entities.customer;
}
